/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebheadline2Inputs */

const en_placewebheadline2 = /** @type {(inputs: Placewebheadline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste your website, we build your profile.`)
};

const de_placewebheadline2 = /** @type {(inputs: Placewebheadline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge deine Website ein, wir bauen dein Profil.`)
};

/**
* | output |
* | --- |
* | "Paste your website, we build your profile." |
*
* @param {Placewebheadline2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebheadline2 = /** @type {((inputs?: Placewebheadline2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebheadline2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebheadline2(inputs)
	return de_placewebheadline2(inputs)
});
export { placewebheadline2 as "placeWebHeadline" }